<template src="./ListProcess.html"></template>
<script>
import { getProcesses } from '../../../services'
import { getProcessCountsByStatus } from '../../../services/process'
import Companies from '../../../components/Forms/Companies/Companies'
import Status from '../../../components/Forms/Status/Status'
import ProgressProcess from '../../../components/ProgressProcess/ProgressProcess'
import { mapGetters } from 'vuex'
import { OnlyRisk, OnlyRiskAndAnalyst, NotAnalyst, OnlyCompany } from '../../../utils/roles'
import { PROCESS_STATUS, SERVICE_STATUS } from '../../../utils/constants'

export default {
  name: 'ListProcess',
  components: { Companies, ProgressProcess, Status },
  data: () => ({
    processes: [],
    menu: false,
    showMore: false,
    search: {
      company: null,
      text: '',
      status: 'PENDING',
      documentId: null,
      fullName: null
    },
    skip: 0,
    disabled: false,
    PROCESS_STATUS,
    processCounts: {
      PENDING: 0,
      ACTIVE: 0
    }
  }),
  created () {
    this.searchProcess()
    this.fetchProcessCounts()
  },
  methods: {
    async searchProcess (addProcess) {
      try {
        const processes = await getProcesses(
          this.search.companyId,
          this.search.status,
          this.search.documentId,
          this.search.fullName,
          this.skip,
          this.take
        )
        if (!addProcess) this.processes = processes
        else this.processes.push(...processes)

        if (this.skip + this.take > this.processes.length) this.disabled = true
        this.fetchProcessCounts()
      } catch (err) {
        console.log('search Process:', err)
      }
    },
    async fetchProcessCounts () {
      try {
        const data = await getProcessCountsByStatus(
          this.search.companyId,
          this.search.documentId,
          this.search.fullName
        )
        this.processCounts = {
          PENDING: data.PENDING || 0,
          ACTIVE: data.ACTIVE || 0
        }
      } catch (err) {
        this.processCounts = { PENDING: 0, ACTIVE: 0 }
        console.log('fetchProcessCounts:', err)
      }
    },
    async getProcessByStatus () {
      this.skip = 0
      this.disabled = false
      await this.searchProcess()
    },
    async moreProcess () {
      this.skip += this.take
      await this.searchProcess(true)
    },
    getProcessProgress (services) {
      if (!services || !services.length) return 0
      const step = 100 / services.length
      return services.reduce((acc, s) =>
        acc + (s.status === SERVICE_STATUS.PENDING || s.status === SERVICE_STATUS.ASSIGNED || s.status === SERVICE_STATUS.IN_PROGRESS ? 0 : step),
      0)
    },
    formatCommentDate (dateStr) {
      const date = new Date(dateStr)
      const diffMins = Math.floor((new Date() - date) / 60000)

      if (diffMins < 1) return 'Ahora'

      return date.toLocaleDateString('es-CO', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      })
    }
  },
  computed: {
    filterProcesses () {
      if (!this.search.text) return this.processes
      const search = this.search.text.toLowerCase()

      return this.processes.filter(
        (process) =>
          process.company.name.toLowerCase().includes(search) ||
          process.evaluated.fullName.toLowerCase().includes(search) ||
          process.evaluated.documentId.toLowerCase().includes(search)
      )
    },
    take () {
      return this.search.status === 'ACTIVE' ? 100 : 50
    },
    isStatus () {
      return (status) => this.search.status !== status
    },
    ...mapGetters({
      user: 'getUser'
    }),
    OnlyRisk,
    OnlyRiskAndAnalyst,
    NotAnalyst,
    OnlyCompany
  }
}
</script>
<style lang="scss" scoped src="./ListProcess.scss"></style>
